import { FC } from "react";
import {
  baseUrl,
  toAbsoluteUrl,
  XHR,
  valortotalDocumentosSeleccionados,
  JWT,
} from "../../../helpers";
import { Iestado } from "../../../helpers/dataExamples";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import moment from "moment";
import { REACT_APP_AMBIENTE_EPAYCO } from "../../../../parametros";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type tipos = {
  keyAccount: string;
  referencia: string;
  amount: number;
  name: string;
  descrip: string;
  currency: string;
  country: string;
  test: boolean;
  external: boolean;
  url_response: string;
  url_comfirm: string;
  email: string;
  estado: Iestado;
  setEstado: React.Dispatch<React.SetStateAction<Iestado>>;
  stpb: React.Dispatch<React.SetStateAction<boolean>>;
};

const EpaycoCheckOut: FC<tipos> = ({
  keyAccount,
  referencia,
  amount,
  name,
  descrip,
  currency,
  country,
  test,
  external,
  url_response,
  url_comfirm,
  email,
  estado,
  setEstado,
  stpb,
}) => {
  const referencias = Object.keys(estado.referencias);

  const MySwal = withReactContent(Swal);

  const dataTransaccion = {
    descripcionProducto: name,
    documentoCliente: estado.documento,
    tipoDocCliente: estado.tipoDocumento,
    nombreCliene: estado.nombres + " " + estado.apellidos,
    telefono: estado.telefono,
    email: estado.correo,
    direccion: estado.direccion,
    valorTotal: valortotalDocumentosSeleccionados(estado),
    idServicio: estado.idServicio,
    fechaVencimiento:
      isNaN(Date.parse(estado.fechaVencimiento)) === true
        ? moment(new Date()).format("YYYY-MM-DD")
        : estado.fechaVencimiento,
    ListDocumento: Array<object>(),
  };

  referencias.forEach((ref, index) => {
    const hacerAbono = estado.referencias[ref].hacer_abono;
    let docu: object = {
      numeroDocumento: estado.referencias[ref].referencia,
      valorDocumento: estado.referencias[ref].valorTotal,
      valorAbono: estado.referencias[ref].valor_abono,
      valorApagar: hacerAbono
        ? estado.referencias[ref].valor_abono
        : estado.referencias[ref].valorMinimo,
      detalleDocumento: estado.referencias[ref].descrip,
      codigoServicio: estado.referencias[ref].codigoServicioSAP,
      fechaVencimiento:
        isNaN(Date.parse(estado.fechaVencimiento)) === true
          ? moment(new Date()).format("YYYY-MM-DD")
          : estado.referencias[ref].limite,
    };
    dataTransaccion.ListDocumento.push(docu);
  });

  const makePay = () => {
    let myWin = window as any;
    console.log(REACT_APP_AMBIENTE_EPAYCO, (REACT_APP_AMBIENTE_EPAYCO+"" === "PRD") ? false : true);
    if (typeof myWin.ePayco == "object") {
      var handler = myWin.ePayco.checkout.configure({
        key: keyAccount,
        test: (REACT_APP_AMBIENTE_EPAYCO+"" === "PRD") ? false : true,
      });

      var dataEpayco = {
        //Parametros compra (obligatorio)
        name: name,
        description: descrip,
        invoice: estado.guidTransaccion,
        currency: "cop",
        amount: amount,
        tax_base: "0",
        tax: "0",
        country: "CO",
        lang: "es",
        external: external ? "true" : "false",

        //Atributos opcionales
        confirmation: url_comfirm,
        response: url_response + "/pagoFinalizado/",

        //Atributos cliente
        name_billing: estado.nombres + " " + estado.apellidos,
        address_billing: estado.direccion,
        type_doc_billing: estado.tipoDocumento.replace(".", ""),
        mobilephone_billing: estado.telefono,
        number_doc_billing: estado.documento,
        email_billing: estado.correo,
        //atributo deshabilitación metodo de pago
        methodsDisable: [
          /*"TDC", "PSE", "SP", "CASH", "DP"*/
        ],
      };

      referencias.forEach((ref, index) => {
        const aa = {
          ["extra" + (index + 1)]: estado.referencias[ref].referencia,
        };
        Object.assign(dataEpayco, aa);
        //data["extra"+index] = estado.referencias[ref].referencia;
      });
      //console.log(dataEpayco, keyAccount);
      //handler.dispose();
      handler.open(dataEpayco);
    }
  };

  const intencionDePago = async () => {

    if(validacionTransaccion() === false){
      alert("Ocurrio un error en la operación intente de nuevo mas tarde(2)!");
      window.location.reload();
    }

    MySwal.fire({
      title: "<strong>¿Está seguro de continuar con el pago?</strong>",
      icon: "info",
      //html: "<strong>¿Esta seguro de continuar con el pago?</strong>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "Continuar",
      confirmButtonAriaLabel: "Thumbs up, great!",
      cancelButtonText: "Cancelar",
      cancelButtonAriaLabel: "Thumbs down",
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      //console.log(result);
      if (result.isConfirmed) {
        let url = baseUrl() + "Transacciones/crearTransaccionEpayco";
        const token = await JWT("PAGOS_EN_LINEA");
        var _headers = { Authorization: "Bearer " + token };


        const resp = await XHR(stpb, url, dataTransaccion, "post", _headers);
        console.log(resp);
        if (resp?.data.exito) {
          const newState = { ...estado };
          estado.guidTransaccion = resp.data.data.id;
          setEstado(newState);
          stpb(true);
          makePay();
        } else {
          //alert(resp?.data.mensaje);
          MySwal.fire({
            title: resp?.data.mensaje,
            icon: "error",
            //html: "<strong>¿Esta seguro de continuar con el pago?</strong>",
            showCloseButton: true,
            focusConfirm: false,
            confirmButtonText: "Continuar",
            confirmButtonAriaLabel: "Thumbs up, great!",
            cancelButtonAriaLabel: "Thumbs down",
          }).then(async (result) => {
            window.location.reload();
          });
          
        }
      }
    });
  };
  
  const validacionTransaccion = (): boolean => {
    if(dataTransaccion.documentoCliente.trim() === "" || 
       dataTransaccion.tipoDocCliente.trim() === "" ||
       dataTransaccion.valorTotal === 0 ||
       Number.isNaN(dataTransaccion.valorTotal)
       ){
        return false;
    }else{
        return true;
    }
  }

  /*return (
    <a className="btn-epayco" onClick={intencionDePago} href="#/">
      <img
        src={toAbsoluteUrl("/media/icons/boton_de_cobro_epayco2.png")}
        alt=""
      ></img>
    </a>
  );*/

  return (
    <a className="btn btn-comfe rounded-pill" onClick={intencionDePago} href="#/">
      <FontAwesomeIcon icon={"dollar-sign"} /> Pagar Aquí
    </a>
  );
};

export { EpaycoCheckOut };
